{
  "fr": {
    "messages": {
      "plaqueTool": {
        "attached": "%{vehicle} porte maintenant la plaque.",
        "hangarFailure": "Ton hangar n'a pas pu être chargé.",
        "createFailure": "Le vaisseau n'a pas pu être ajouté à ton hangar.",
        "addedWithoutPlaque": "Le vaisseau est dans ton hangar, mais sa plaque n'a pas pu être enregistrée. Réessaie pour la poser.",
        "replaceConfirm": "Ce vaisseau a déjà une plaque. La remplacer ?"
      },
      "blueprint": {
        "own": { "success": "%{blueprint} est marqué comme possédé" },
        "unown": { "success": "%{blueprint} n'est plus marqué comme possédé" },
        "want": {
          "success": "%{blueprint} a été ajouté à votre liste de souhaits"
        },
        "unwant": {
          "success": "%{blueprint} a été retiré de votre liste de souhaits"
        }
      },
      "fleetchartScreenshot": {
        "failure": "Le graphique de la flotte n'a pas pu être enregistré en image"
      },
      "buyback": {
        "destroy": {
          "failure": "Impossible de retirer le pledge de rachat."
        }
      },
      "hangarShare": {
        "enable": {
          "success": "Lien de partage créé.",
          "failure": "Impossible de créer le lien de partage."
        },
        "rotate": {
          "success": "Lien de partage renouvelé. L'ancien lien ne fonctionne plus.",
          "failure": "Impossible de renouveler le lien de partage.",
          "confirm": "Renouveler le lien rend l'actuel inutilisable. Les personnes avec qui vous l'avez partagé auront besoin du nouveau lien."
        },
        "disable": {
          "success": "Lien de partage supprimé.",
          "failure": "Impossible de supprimer le lien de partage.",
          "confirm": "Supprimer le lien le rend inutilisable pour toutes les personnes avec qui vous l'avez partagé."
        },
        "copy": {
          "success": "Lien de partage copié dans le presse-papiers.",
          "failure": "Impossible de copier le lien de partage."
        }
      },
      "loading": "Chargement…",
      "copy": {
        "success": "Texte copié !",
        "failure": "Impossible de copier le texte"
      },
      "copyGitRevision": {
        "success": "Révision Git copiée !",
        "failure": "Impossible de copier la révision Git"
      },
      "copyImageUrl": {
        "success": "URL de l'image copiée !",
        "failure": "Impossible de copier l'URL de l'image"
      },
      "copyVideoUrl": {
        "success": "URL de la vidéo copiée !",
        "failure": "Impossible de copier l'URL de la vidéo"
      },
      "copyShareUrl": {
        "success": "URL \"%{url}\" copiée !",
        "failure": "Impossible de copier l'URL"
      },
      "copyInviteUrl": {
        "success": "URL d'invitation \"%{url}\" copiée !",
        "failure": "Impossible de copier l'URL d'invitation"
      },
      "copyTwoFactorProvisioningUrl": {
        "success": "URL de provisionnement copiée !",
        "failure": "Impossible de copier l'URL de provisionnement"
      },
      "copyBackupCodes": {
        "success": "Codes de sauvegarde copiés !",
        "failure": "Impossible de copier les codes de sauvegarde"
      },
      "signup": {
        "success": "<b>Bienvenue sur FleetYards.net !</b> Votre compte a été créé. <br>Vous recevrez un email de confirmation pour activer votre compte.",
        "invalid": "Veuillez résoudre les erreurs avant que votre compte puisse être créé.",
        "failure": "Nous n'avons pas pu créer votre compte. Veuillez réessayer plus tard."
      },
      "accountConfirm": {
        "success": "Votre compte a été confirmé avec succès.<br>Vous pouvez maintenant vous connecter.",
        "failure": "Votre compte n'a pas pu être confirmé."
      },
      "requestPasswordChange": {
        "success": "Si votre adresse email existe dans notre base de données, vous recevrez un lien de récupération de mot de passe à votre adresse email dans quelques minutes."
      },
      "changePassword": {
        "success": "Votre mot de passe a été modifié avec succès.",
        "failure": "Votre mot de passe n'a pas pu être mis à jour."
      },
      "modelModule": {
        "update": {
          "failure": "Le module n’a pas pu être enregistré."
        }
      },
      "updateProfile": {
        "success": "Profil mis à jour.",
        "failure": "Profile could not be updated."
      },
      "updateHangar": {
        "failure": "Les paramètres du hangar n'ont pas pu être mis à jour.",
        "success": "Paramètres du Hangar mis à jour."
      },
      "updatePrivacy": {
        "success": "Paramètres de confidentialité mis à jour."
      },
      "features": {
        "updated": "Fonctionnalité mise à jour.",
        "error": "Impossible de mettre à jour la fonctionnalité.",
        "actorAdded": "Acteur ajouté à la fonctionnalité.",
        "actorRemoved": "Acteur retiré de la fonctionnalité.",
        "groupAdded": "Groupe ajouté à la fonctionnalité.",
        "groupRemoved": "Groupe retiré de la fonctionnalité.",
        "created": "Fonctionnalité créée.",
        "destroyed": "Fonctionnalité supprimée."
      },
      "rsiRequestLogs": {
        "resolved": "Journal de requêtes marqué comme résolu.",
        "error": "Impossible de mettre à jour le journal de requêtes."
      },
      "updateNotifications": {
        "success": "Paramètres de notification mis à jour.",
        "failure": "Impossible d'enregistrer vos paramètres de notification."
      },
      "pushNotifications": {
        "failure": "Les notifications push n'ont pas pu être mises à jour."
      },
      "updateAccount": {
        "success": "Compte mis à jour."
      },
      "oauthApplications": {
        "create": {
          "success": "Application OAuth créée.",
          "error": "Impossible de créer l'application OAuth."
        },
        "update": {
          "success": "Application OAuth mise à jour.",
          "error": "Impossible de mettre à jour l'application OAuth."
        },
        "destroy": {
          "success": "Application OAuth supprimée.",
          "error": "Impossible de supprimer l'application OAuth."
        },
        "regenerateSecret": {
          "success": "Secret client régénéré.",
          "error": "Impossible de régénérer le secret client."
        },
        "copied": "Copié dans le presse-papiers.",
        "copyError": "Impossible de copier dans le presse-papiers.",
        "secretWarning": "Copiez votre secret client maintenant. Vous ne pourrez plus le voir."
      },
      "hangarImport": {
        "success": "Importation terminée",
        "partialSuccess": "Importation partiellement terminée.<br><br>Vaisseaux non trouvés : <br>%{missing}",
        "failure": "Échec de l'importation",
        "queued": "Import mis en file. Vous pouvez le suivre ici."
      },
      "hangarExport": {
        "failure": "Échec de l'exportation, veuillez réessayer plus tard."
      },
      "vehicle": {
        "move": {
          "failure": "L'ordre n'a pas pu être enregistré."
        },
        "add": {
          "success": {
            "noHtml": "Your new %{model} will be delivered to your Hangar",
            "paragraph1": "Your new ",
            "paragraph2": "will be delivered to your "
          }
        },
        "addToWishlist": {
          "success": {
            "noHtml": "Your new %{model} was added to your Wishlist",
            "paragraph2": "was added to your "
          }
        },
        "resetIngame": {
          "moveToWishlist": {
            "success": "Tous les vaisseaux achetés en jeu ont été déplacés vers votre liste de souhaits.",
            "failure": "Impossible de déplacer tous les vaisseaux achetés en jeu vers votre liste de souhaits."
          },
          "removeAll": {
            "confirm": "Supprimer de votre hangar tous les vaisseaux achetés en jeu ? Cette action est irréversible.",
            "success": "Tous les vaisseaux achetés en jeu ont été supprimés de votre Hangar.",
            "failure": "Impossible de supprimer tous les vaisseaux achetés en jeu de votre Hangar."
          }
        }
      },
      "model": {
        "syncMatrixStarted": "Model matrix sync started. You will be notified when it completes.",
        "syncScDataStarted": "Model SC data sync started. You will be notified when it completes.",
        "importPaintsStarted": "Import des peintures démarré. Vous serez notifié lorsqu'il sera terminé.",
        "syncShipViewsStarted": "Synchronisation des vues du vaisseau démarrée. Les nouveaux rendus apparaîtront ici une fois traités.",
        "dimensionsDrifted": "Ces dimensions diffèrent des fichiers de jeu."
      },
      "announcement": {
        "created": "Annonce créée.",
        "updated": "Annonce mise à jour.",
        "destroyed": "Annonce supprimée.",
        "destroyFailed": "Impossible de supprimer l'annonce.",
        "createFailed": "L'annonce n'a pas pu être créée.",
        "updateFailed": "L'annonce n'a pas pu être mise à jour.",
        "testSent": "Test envoyé sur le canal Discord d'administration.",
        "testFailed": "Le test n'a pas pu être envoyé.",
        "published": "L'annonce est en route.",
        "publishFailed": "L'annonce n'a pas pu être envoyée.",
        "retryQueued": "Envoi remis en file.",
        "retryFailed": "Cet envoi n'a pas pu être relancé.",
        "refreshQueued": "Les chiffres sont en cours d'actualisation.",
        "refreshFailed": "Impossible d'actualiser les chiffres."
      },
      "fundingGoal": {
        "created": "Objectif de financement créé.",
        "updated": "Objectif de financement mis à jour.",
        "destroyed": "Objectif de financement supprimé.",
        "createFailed": "Impossible de créer l'objectif de financement.",
        "updateFailed": "Impossible de mettre à jour l'objectif de financement."
      },
      "homepageSetting": {
        "updated": "Page d’accueil enregistrée.",
        "updateFailed": "Impossible d’enregistrer la page d’accueil."
      },
      "gameEvent": {
        "created": "Événement du jeu créé.",
        "updated": "Événement du jeu mis à jour.",
        "destroyed": "Événement du jeu supprimé.",
        "createFailed": "Impossible de créer l'événement du jeu.",
        "updateFailed": "Impossible de mettre à jour l'événement du jeu."
      },
      "supporterNomination": {
        "update": {
          "success": "Sélection de la flotte mise à jour.",
          "failure": "La sélection de la flotte n'a pas pu être mise à jour."
        },
        "change": {
          "confirm": "%{fleet} risque de perdre les fonctionnalités de flotte dont elle dispose actuellement. Continuer ?"
        }
      },
      "supporterContribution": {
        "created": "Contribution de soutien créée.",
        "updated": "Contribution de soutien mise à jour.",
        "destroyed": "Contribution de soutien supprimée.",
        "createFailed": "Impossible de créer la contribution de soutien.",
        "updateFailed": "Impossible de mettre à jour la contribution de soutien."
      },
      "notification": {
        "granted": "Bienvenue aux notifications FleetYards.net !"
      },
      "twoFactor": {
        "enable": {
          "success": "Authentification à deux facteurs activée !",
          "failure": "Impossible d'activer l'authentification à deux facteurs."
        },
        "disable": {
          "success": "Authentification à deux facteurs désactivée !",
          "failure": "Impossible de désactiver l'authentification à deux facteurs."
        },
        "backupCodes": {
          "failure": "Les codes de sauvegarde n'ont pas pu être générés."
        }
      },
      "error": {
        "usernameTaken": "Le nom d'utilisateur est déjà pris.",
        "userNotFound": "Utilisateur non trouvé",
        "emailTaken": "L'email est déjà pris.",
        "fleetTaken": "La flotte est déjà prise.",
        "colorInvalid": "Color is invalid",
        "serialTaken": "Le numéro de série est déjà pris.",
        "textInvalid": "%{field} n'est pas valide",
        "fleetNameInvalid": "Le champ %{field} ne peut contenir que des caractères alphanumériques, des espaces, des points, des tirets et des tirets bas",
        "vehicleSerialInvalid": "Le champ %{field} doit avoir le format de l’immatriculation affichée dans le jeu, par exemple L8-4261-HA",
        "hangar": {
          "accountRequired": {
            "noHtml": "You need to Sign up or Login to add Ships to your Hangar.",
            "paragraph1": "You need to ",
            "paragraph2": " to add Ships to your Hangar.",
            "paragraph3": "Get more Information "
          }
        },
        "blueprint": {
          "accountRequired": "Inscrivez-vous ou connectez-vous pour suivre les plans que vous possédez.",
          "update": "Impossible de mettre à jour ce plan. Veuillez réessayer."
        },
        "default": "<b>Quelque chose s'est mal passé.</b> <br>Avez-vous essayé de l'éteindre et de le rallumer ?"
      },
      "account": {
        "destroy": {
          "success": "<b>Votre compte a été supprimé.</b> <br>Désolé de vous voir partir :'(",
          "failure": "Nous n'avons pas pu supprimer votre compte ! Veuillez réessayer plus tard."
        },
        "calendarSubscription": {
          "enable": {
            "success": "Abonnement au calendrier personnel activé.",
            "failure": "Impossible d'activer l'abonnement au calendrier."
          },
          "rotate": {
            "success": "Lien de calendrier personnel renouvelé. Les abonnés actuels ne recevront plus de mises à jour tant qu'ils ne se seront pas réabonnés.",
            "failure": "Impossible de renouveler le lien de calendrier personnel.",
            "confirm": "Renouveler le lien invalidera silencieusement toute application de calendrier abonnée à l'URL actuelle. Vous devrez vous réabonner avec le nouveau lien."
          },
          "disable": {
            "success": "Abonnement au calendrier personnel désactivé.",
            "failure": "Impossible de désactiver l'abonnement au calendrier personnel.",
            "confirm": "Désactiver l'abonnement coupera le flux pour toute application de calendrier actuellement abonnée."
          }
        },
        "supporterClaimKey": {
          "copy": {
            "success": "Clé copiée.",
            "failure": "La clé n'a pas pu être copiée."
          }
        }
      },
      "user": {
        "destroy": {
          "success": "Utilisateur supprimé.",
          "failure": "Impossible de supprimer l'utilisateur."
        }
      },
      "fleet": {
        "fidClaim": {
          "create": {
            "success": "Réclamation ouverte. La flotte qui détient l’ID a été prévenue.",
            "failure": "L’ID de flotte n’a pas pu être réclamé."
          },
          "destroy": {
            "success": "Réclamation retirée.",
            "failure": "La réclamation n’a pas pu être retirée."
          },
          "endNow": {
            "success": "Délai de grâce terminé.",
            "failure": "Le délai de grâce n’a pas pu être terminé."
          },
          "cancel": {
            "success": "Réclamation annulée.",
            "failure": "La réclamation n’a pas pu être annulée."
          }
        },
        "create": {
          "success": "Votre flotte a été créée.",
          "failure": "La flotte n'a pas pu être sauvegardée."
        },
        "update": {
          "success": "Paramètres sauvegardés.",
          "failure": "Les paramètres n'ont pas pu être sauvegardés."
        },
        "destroy": {
          "success": "Votre flotte a été supprimée.",
          "failure": "Nous n'avons pas pu supprimer votre flotte."
        },
        "leave": {
          "success": "Vous avez quitté la flotte.",
          "failure": "Impossible de quitter la flotte."
        },
        "invites": {
          "accept": {
            "success": "Invitation acceptée.",
            "failure": "Impossible d'accepter l'invitation."
          },
          "decline": {
            "success": "Invitation déclinée.",
            "failure": "Impossible de décliner l'invitation."
          },
          "create": {
            "failure": "Impossible d'inviter l'utilisateur."
          }
        },
        "members": {
          "update": {
            "success": "Paramètres sauvegardés.",
            "failure": "Les paramètres n'ont pas pu être sauvegardés."
          },
          "destroy": {
            "success": "Membre supprimé.",
            "failure": "Le membre n'a pas pu être supprimé."
          },
          "demote": {
            "success": "Membre rétrogradé.",
            "failure": "Le membre n'a pas pu être rétrogradé."
          },
          "promote": {
            "success": "Membre promu.",
            "failure": "Le membre n'a pas pu être promu."
          },
          "accept": {
            "success": "Membre accepté.",
            "failure": "Le membre n'a pas pu être accepté."
          },
          "decline": {
            "success": "Membre décliné.",
            "failure": "Le membre n'a pas pu être décliné."
          },
          "nickname": {
            "success": "Surnom enregistré.",
            "failure": "Le surnom n'a pas pu être enregistré."
          }
        },
        "roles": {
          "update": {
            "success": "Rôle enregistré.",
            "failure": "Le rôle n'a pas pu être enregistré."
          }
        },
        "squadrons": {
          "create": {
            "success": "Escadron créé.",
            "failure": "L'escadron n'a pas pu être créé."
          },
          "update": {
            "success": "Escadron enregistré.",
            "failure": "L'escadron n'a pas pu être enregistré."
          },
          "destroy": {
            "confirm": "Dissoudre l'escadron « %{name} » ? Ses membres restent dans la flotte.",
            "success": "Escadron dissous.",
            "failure": "L'escadron n'a pas pu être dissous."
          },
          "sort": {
            "failure": "L'ordre n'a pas pu être enregistré."
          },
          "ranks": {
            "update": {
              "success": "Grades d'escadron enregistrés.",
              "failure": "Les grades d'escadron n'ont pas pu être enregistrés."
            }
          },
          "members": {
            "add": {
              "success": "%{count} membres ajoutés.",
              "failure": "%{count} membres n'ont pas pu être ajoutés."
            },
            "destroy": {
              "confirm": "Retirer %{username} de l'escadron %{squadron} ? La personne reste dans la flotte.",
              "success": "Membre retiré de l'escadron.",
              "failure": "Le membre n'a pas pu être retiré."
            }
          },
          "join": {
            "success": "Vous avez rejoint l'équipe.",
            "failure": "Impossible de rejoindre l'équipe."
          },
          "leave": {
            "confirm": "Quitter l'escadron %{squadron} ? Vous restez dans la flotte.",
            "success": "Vous avez quitté l'escadron.",
            "failure": "Impossible de quitter l'escadron."
          },
          "requests": {
            "create": {
              "success": "Demande envoyée. La direction de l'escadron y répondra.",
              "failure": "La demande n'a pas pu être envoyée."
            },
            "withdraw": {
              "success": "Demande retirée.",
              "failure": "La demande n'a pas pu être retirée."
            },
            "blocked": {
              "member": "Tu es déjà dans %{squadron}. Quitte-le avant de demander à rejoindre un autre escadron.",
              "requested": "Tu as demandé à rejoindre %{squadron}. Retire cette demande avant d'en faire une autre."
            },
            "accept": {
              "success": "%{username} a rejoint l'escadron.",
              "failure": "La demande n'a pas pu être acceptée."
            },
            "decline": {
              "success": "Demande refusée.",
              "failure": "La demande n'a pas pu être refusée."
            }
          },
          "rank": {
            "success": "Grade modifié.",
            "failure": "Le grade n'a pas pu être modifié."
          }
        },
        "calendarSubscription": {
          "enable": {
            "success": "Abonnement au calendrier activé.",
            "failure": "Impossible d'activer l'abonnement au calendrier."
          },
          "rotate": {
            "success": "Lien d'abonnement renouvelé. Les abonnés actuels ne recevront plus de mises à jour tant qu'ils ne se seront pas réabonnés.",
            "failure": "Impossible de renouveler le lien d'abonnement.",
            "confirm": "Renouveler le lien invalidera silencieusement toute application de calendrier abonnée à l'URL actuelle. Ils devront se réabonner avec le nouveau lien."
          },
          "disable": {
            "success": "Abonnement au calendrier désactivé.",
            "failure": "Impossible de désactiver l'abonnement au calendrier.",
            "confirm": "Désactiver l'abonnement coupera le flux pour toute application de calendrier actuellement abonnée."
          },
          "copy": {
            "success": "Lien du calendrier copié. Collez-le dans votre application de calendrier sous « S'abonner à un calendrier » ou « Ajouter par URL ».",
            "failure": "Impossible de copier le lien du calendrier."
          }
        }
      },
      "fleetInvite": {
        "used": "<b>Demande d'adhésion pour %{fleet} envoyée !</b><br>Une fois votre adhésion acceptée, vous serez notifié par email",
        "failure": "L'invitation n'a pas pu être utilisée.",
        "confirm": "Êtes-vous sûr de vouloir rejoindre la flotte : \"%{fleet}\" ?"
      },
      "holoViewer": {
        "modelLoader": {
          "failure": "Nous n'avons pas pu charger le modèle 3D demandé ! Veuillez réessayer plus tard."
        },
        "webglNotSupported": "La visionneuse 3D n'est pas disponible sur cet appareil.",
        "tooLarge": "Ce modèle 3D fait %{size} Mo et pourrait être trop volumineux pour cet appareil."
      },
      "cargoGridViewer": {
        "confirmReset": "Are you sure you want to reset all ships and container settings?"
      },
      "confirm": {
        "vehicleLoadout": {
          "moduleContents": {
            "one": "La pièce montée dans ce module part avec lui.",
            "other": "Les %{count} pièces montées dans ce module partent avec lui."
          }
        },
        "vehicle": {
          "destroy": "Êtes-vous sûr de vouloir supprimer ce vaisseau de votre Hangar ?"
        },
        "buyback": {
          "destroy": "Retirer ce pledge de votre liste de rachat ? À utiliser après l'avoir racheté sur RSI. La prochaine synchronisation le rétablit s'il y figure encore."
        },
        "hangarGroup": {
          "destroy": "Êtes-vous sûr de vouloir supprimer ce groupe de votre Hangar ?"
        },
        "hangar": {
          "import": "Les vaisseaux importés seront ajoutés à votre Hangar sans correspondance avec les vaisseaux existants.<br><br>Les formats supportés sont : Fleetyards Export ou HangarXplor.<br><br>Voulez-vous continuer ?",
          "destroySelected": "Êtes-vous sûr de vouloir supprimer tous les vaisseaux sélectionnés de votre Hangar ? Cette action ne peut pas être annulée.",
          "destroyAll": "Êtes-vous sûr de vouloir supprimer tous les vaisseaux de votre Hangar ? Cette action ne peut pas être annulée.",
          "destroyAllTitle": "Supprimer tous les vaisseaux ?"
        },
        "wishlist": {
          "destroyAll": "Êtes-vous sûr de vouloir supprimer tous les vaisseaux de votre liste de souhaits ? Cette action ne peut pas être annulée."
        },
        "account": {
          "destroy": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action ne peut pas être annulée.",
          "destroyWithFleets": "Vous êtes l'administrateur de la ou des flottes suivantes : %{fleets}. Supprimer votre compte supprimera également ces flottes et retirera tous leurs membres. Cette action est irréversible. Continuer ?"
        },
        "itemPrice": {
          "destroy": "Are you sure you want to destroy this Item Price? This Action can't be reverted."
        },
        "fleet": {
          "leave": "Êtes-vous sûr de vouloir quitter la flotte ? Cette action ne peut pas être annulée.",
          "destroy": "Êtes-vous sûr de vouloir supprimer votre flotte ? Cette action ne peut pas être annulée.",
          "members": {
            "destroy": "Êtes-vous sûr de vouloir supprimer ce membre ?",
            "remove": "Voulez-vous vraiment retirer ce membre de la flotte ?"
          },
          "invites": {
            "decline": "Êtes-vous sûr de vouloir décliner cette invitation ? Cette action ne peut pas être annulée."
          }
        },
        "oauthApplication": {
          "destroy": "Êtes-vous sûr de vouloir supprimer cette application OAuth ? Cette action est irréversible.",
          "regenerateSecret": "Êtes-vous sûr de vouloir régénérer le secret client ? Les intégrations existantes cesseront de fonctionner."
        },
        "twoFactor": {
          "generateBackupCodes": "Êtes-vous sûr de vouloir régénérer vos codes de sauvegarde d'authentification à deux facteurs ?"
        },
        "user": {
          "loginAs": "Are you sure you want to login as this user?",
          "resendConfirmation": "Are you sure you want to resend the confirmation email for this user?",
          "sendPasswordReset": "Are you sure you want to send a password reset email for this user?",
          "destroy": "Are you sure you want to delete this user? This action can't be reverted.",
          "destroyWithFleets": "Cet utilisateur est l'administrateur de la ou des flottes suivantes : %{fleets}. Supprimer l'utilisateur supprimera également ces flottes et retirera tous leurs membres. Cette action est irréversible. Continuer ?"
        },
        "model": {
          "destroy": "Are you sure you want to delete this model? This action can't be reverted.",
          "sync": "Are you sure you want to sync this model from RSI?",
          "syncMatrix": "Are you sure you want to sync the ship matrix data for this model?",
          "syncScData": "Are you sure you want to sync the SC data for this model?",
          "importPaints": "Êtes-vous sûr de vouloir importer les peintures de ce modèle depuis les données du hangar ? Une peinture que la source attribue à toute une série est importée pour chaque modèle de cette série.",
          "syncShipViews": "Êtes-vous sûr de vouloir synchroniser les vues du vaisseau de ce modèle depuis le bucket de rendus ? Les rendus nouveaux et modifiés sont attachés, et ceux supprimés reviennent. Une vue téléversée à la main par-dessus un rendu importé est conservée.",
          "exchangeStoreImage": "Are you sure you want to replace the store image with the RSI image?",
          "reloadMatrix": "Are you sure you want to reload the models matrix? This will enqueue background jobs.",
          "reloadScData": "Are you sure you want to reload SC data? This will enqueue background jobs.",
          "reloadPaints": "Êtes-vous sûr de vouloir recharger les peintures ? Cela mettra des tâches en file d'attente en arrière-plan.",
          "reloadModules": "Êtes-vous sûr de vouloir recharger les modules ? Cela mettra des tâches en file d'attente en arrière-plan.",
          "reloadLoaners": "Êtes-vous sûr de vouloir recharger les prêts ? Cela mettra des tâches en file d'attente en arrière-plan."
        },
        "manufacturer": {
          "destroy": "Are you sure you want to delete this manufacturer? This action can't be reverted."
        },
        "announcement": {
          "publish": "Envoyer cette annonce à %{channels} ? L'envoi est irréversible.",
          "destroy": "Êtes-vous sûr de vouloir supprimer cette annonce ? Cette action est irréversible."
        },
        "fundingGoal": {
          "destroy": "Êtes-vous sûr de vouloir supprimer cet objectif de financement ? Cette action est irréversible."
        },
        "gameEvent": {
          "destroy": "Voulez-vous vraiment supprimer cet événement du jeu ? Cette action est irréversible."
        },
        "supporterContribution": {
          "destroy": "Êtes-vous sûr de vouloir supprimer cette contribution de soutien ? Cette action est irréversible."
        },
        "modelPosition": {
          "destroy": "Êtes-vous sûr de vouloir supprimer ce poste ? Cette action est irréversible."
        },
        "modelLoaner": {
          "destroy": "Êtes-vous sûr de vouloir supprimer ce prêt ? Cette action est irréversible."
        },
        "modelSnubCraft": {
          "destroy": "Êtes-vous sûr de vouloir supprimer ce snub craft ? Cette action est irréversible."
        },
        "modelPaint": {
          "destroy": "Are you sure you want to delete this paint? This action can't be reverted."
        },
        "video": {
          "destroy": "Are you sure you want to delete this video? This action can't be reverted."
        },
        "modelModule": {
          "destroy": "Are you sure you want to delete this module? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this module from the model? The module will still exist but won't be associated with this model."
        },
        "modelUpgrade": {
          "destroy": "Are you sure you want to delete this upgrade? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this upgrade from the model? The upgrade will still exist but won't be associated with this model."
        },
        "modelModulePackage": {
          "destroy": "Are you sure you want to delete this module package? This action can't be reverted."
        },
        "dockCapacity": {
          "destroy": "Voulez-vous vraiment supprimer cette entrée de capacité ? Cette action est irréversible."
        },
        "dock": {
          "destroy": "Are you sure you want to delete this dock? This action can't be reverted."
        },
        "component": {
          "destroy": "Are you sure you want to delete this component? This action can't be reverted."
        },
        "adminFleet": {
          "destroy": "Are you sure you want to delete this fleet? This action can't be reverted."
        },
        "adminNotifications": {
          "destroyAll": "Êtes-vous sûr de vouloir supprimer toutes les notifications ? Cette action est irréversible.",
          "destroySelected": {
            "one": "Êtes-vous sûr de vouloir supprimer la notification sélectionnée ? Cette action est irréversible.",
            "other": "Êtes-vous sûr de vouloir supprimer les %{count} notifications sélectionnées ? Cette action est irréversible."
          }
        },
        "adminFleetFidClaim": {
          "endNow": "Terminer le délai de grâce maintenant ? La flotte qui détient l’ID est renommée et celle qui le réclame le reçoit tout de suite.",
          "cancel": "Annuler cette réclamation ? Les deux flottes sont prévenues, et celle qui détient l’ID le garde."
        },
        "fleetFidClaim": {
          "create": "Réclamer l’ID de flotte %{fid} ? La flotte qui le détient est prévenue maintenant et perd l’ID dans 14 jours, sauf si elle prouve elle-même l’organisation RSI."
        },
        "adminDestroyedFleet": {
          "restore": "Êtes-vous sûr de vouloir restaurer cette flotte ?",
          "restorePurged": "Êtes-vous sûr de vouloir restaurer cette flotte purgée ? La restauration est faite au mieux : les rôles, les images, les liens d'invitation et les véhicules de flotte ne sont pas restaurés."
        },
        "adminUser": {
          "destroy": "Are you sure you want to delete this admin user? This action can't be reverted."
        },
        "image": {
          "destroy": "Are you sure you want to delete this image? This action can't be reverted."
        },
        "adminVehicle": {
          "destroy": "Are you sure you want to delete this vehicle? This action can't be reverted."
        },
        "commodity": {
          "destroy": "Are you sure you want to delete this commodity? This action can't be reverted."
        },
        "equipment": {
          "destroy": "Are you sure you want to delete this equipment? This action can't be reverted."
        },
        "notifications": {
          "destroyAll": "Êtes-vous sûr de vouloir supprimer toutes les notifications ? Cette action est irréversible.",
          "destroySelected": {
            "one": "Êtes-vous sûr de vouloir supprimer la notification sélectionnée ? Cette action est irréversible.",
            "other": "Êtes-vous sûr de vouloir supprimer les %{count} notifications sélectionnées ? Cette action est irréversible."
          }
        },
        "unlistedModel": {
          "createModel": "Créer un vaisseau à partir de %{name} ? Le prochain chargement sc_data complétera ses caractéristiques."
        },
        "import": {
          "cleanup": "Marquer cet import comme échoué ? À ne faire que si le job a vraiment disparu : une exécution encore active échouera à la fin.",
          "cleanupSelected": "Marquer les imports sélectionnés comme échoués ? Seuls ceux encore en cours sont concernés, et une exécution réellement encore active échouera à la fin.",
          "cancel": "Arrêter cet import ? Les vaisseaux déjà ajoutés sont conservés."
        },
        "hardpoint": {
          "destroy": "Êtes-vous sûr de vouloir supprimer ce point d'attache ? Cette action est irréversible."
        },
        "fleets": {
          "contractItem": {
            "destroy": "Retirer ces marchandises du contrat ?"
          }
        },
        "vehicleLog": {
          "destroy": "Veux-tu vraiment supprimer cette entrée du journal ?"
        }
      },
      "oauthAuthorize": {
        "loading": "Chargement...",
        "loadError": "Échec du chargement des détails d'autorisation.",
        "authorizeError": "Autorisation échouée.",
        "denyError": "Le refus d'autorisation a échoué."
      },
      "oauth": {
        "disconnect": {
          "success": "Fournisseur déconnecté avec succès.",
          "failure": "Impossible de déconnecter le fournisseur. Veuillez réessayer."
        }
      },
      "confirmAccess": {
        "failure": "L'accès n'a pas pu être confirmé. Veuillez vérifier votre mot de passe et réessayer."
      },
      "setEmail": {
        "success": "Un e-mail de confirmation a été envoyé à votre nouvelle adresse. Veuillez vérifier votre boîte de réception.",
        "failure": "Impossible de mettre à jour l'adresse e-mail. Veuillez réessayer."
      },
      "confirmAccessEmail": {
        "sent": "Un code de confirmation a été envoyé à votre e-mail.",
        "failure": "Impossible d'envoyer l'e-mail de confirmation. Veuillez réessayer."
      },
      "confirmAccessCode": {
        "failure": "Le code de confirmation est invalide ou a expiré."
      },
      "import": {
        "started": "Import de %{type} démarré...",
        "finished": "Import de %{type} terminé avec succès.",
        "failed": "Import de %{type} échoué : %{info}"
      },
      "buybackSync": {
        "started": "Synchronisation de vos pledges rachetables...",
        "success": "Vos pledges rachetables ont été synchronisés.",
        "failure": "Vos pledges rachetables n'ont pas pu être synchronisés.",
        "detailsSuccess": "Les prix et assurances de vos pledges rachetables sont à jour."
      },
      "syncExtension": {
        "started": "Synchronisation de votre Hangar...",
        "success": "Votre Hangar a été synchronisé.",
        "failure": "Votre Hangar n'a pas pu être synchronisé.",
        "cancelled": "La synchronisation du hangar a été annulée.",
        "pageNotRecognised": "La page de RSI ne ressemble pas à ce qu’attend FleetYards, la synchronisation s’est donc arrêtée sans rien modifier.",
        "nothingToSync": "FleetYards n’a trouvé aucun vaisseau, peinture ou composant dans votre hangar RSI, rien n’a donc été modifié.",
        "onlySkippedItems": "Votre hangar RSI ne contient que des peintures ou des décorations de hangar, que cette synchronisation est réglée pour ignorer, rien n’a donc été modifié.",
        "nothingReadable": "Certains éléments de votre hangar RSI n’ont pas pu être lus et FleetYards n’a rien trouvé d’autre, rien n’a donc été modifié.",
        "notLoggedIn": "Vous devez être connecté sur <a href=\"https://robertsspaceindustries.com\" target=\"_blank\">https://robertsspaceindustries.com</a> pour synchroniser votre Hangar."
      },
      "admin": {
        "form": {
          "created": "Créé.",
          "updated": "Modifications enregistrées."
        },
        "importLoaders": {
          "started": "%{name} démarré.",
          "failed": "Impossible de démarrer %{name}."
        },
        "supporterContributions": {
          "patreonSyncStarted": "Synchronisation Patreon démarrée. Actualisez dans une minute pour voir les soutiens importés."
        },
        "imports": {
          "cleaned": "Import marqué comme échoué",
          "cleanedUp": {
            "one": "%{count} import marqué comme échoué",
            "other": "%{count} imports marqués comme échoués"
          },
          "noneRunning": "Rien dans la sélection n'était encore en cours",
          "cleanupError": "L'import n'a pas pu être nettoyé"
        }
      },
      "logistics": {
        "request": {
          "create": {
            "success": "Logistics request created.",
            "failure": "Could not create logistics request."
          }
        },
        "inventory": {
          "create": {
            "success": "Inventory created.",
            "failure": "Could not create inventory."
          },
          "update": {
            "success": "Inventory updated.",
            "failure": "Could not update inventory."
          },
          "destroy": {
            "success": "Inventory deleted.",
            "failure": "Could not delete inventory."
          }
        },
        "inventoryItem": {
          "create": {
            "success": "Item added to inventory.",
            "failure": "Could not add item to inventory."
          },
          "deposit": {
            "success": "Deposit recorded.",
            "failure": "Could not record deposit."
          },
          "withdrawal": {
            "success": "Withdrawal recorded.",
            "failure": "Could not record withdrawal. Check available stock."
          },
          "destroy": {
            "success": "Entry deleted.",
            "failure": "Could not delete entry.",
            "confirm": "Delete this entry? The stock it added or removed is corrected accordingly."
          }
        },
        "comment": {
          "create": {
            "success": "Comment added.",
            "failure": "Could not add comment."
          }
        },
        "csvImport": {
          "success": "%{count} items imported successfully.",
          "failure": "Could not import CSV file."
        },
        "stockItem": {
          "update": {
            "success": "Item updated.",
            "failure": "Could not update item."
          },
          "destroy": {
            "success": "Item deleted.",
            "failure": "Could not delete item.",
            "confirm": "Delete this item and all %{count} of its entries? This cannot be undone."
          }
        },
        "vehicleInventory": {
          "clear": {
            "confirm": "Vider la cargaison de ce vaisseau ? Toutes les entrées seront supprimées.",
            "success": "Cargaison vidée.",
            "failure": "Impossible de vider la cargaison."
          }
        },
        "transfer": {
          "needsAnswer": "Le destinataire doit accepter avant réception. Le stock quitte votre inventaire maintenant et revient s'il refuse.",
          "create": {
            "failure": "Impossible d'envoyer le transfert"
          },
          "resolve": {
            "failure": "Impossible de mettre à jour le transfert"
          },
          "reportHint": "Signaler refuse le transfert, renvoie les marchandises et empêche cet expéditeur de vous recontacter."
        }
      },
      "adminNotifications": {
        "read": "Notification marquée comme lue",
        "unread": "Notification marquée comme non lue",
        "archived": "Notification archivée",
        "unarchived": "Notification remise dans la boîte de réception",
        "readAll": "Toutes les notifications ont été marquées comme lues",
        "destroyed": "Notification supprimée",
        "destroyedAll": "Toutes les notifications ont été supprimées",
        "error": "Une erreur est survenue",
        "bulk": {
          "read": {
            "one": "%{count} notification marquée comme lue",
            "other": "%{count} notifications marquées comme lues"
          },
          "unread": {
            "one": "%{count} notification marquée comme non lue",
            "other": "%{count} notifications marquées comme non lues"
          },
          "archived": {
            "one": "%{count} notification archivée",
            "other": "%{count} notifications archivées"
          },
          "unarchived": {
            "one": "%{count} notification remise dans la boîte de réception",
            "other": "%{count} notifications remises dans la boîte de réception"
          },
          "destroyed": {
            "one": "%{count} notification supprimée",
            "other": "%{count} notifications supprimées"
          }
        }
      },
      "fleets": {
        "notifications": {
          "update": {
            "success": "Paramètres de notification enregistrés.",
            "failure": "Impossible d'enregistrer les paramètres de notification."
          }
        },
        "mission": {
          "publish": {
            "success": "Mission publiée — la flotte peut la voir.",
            "failure": "Impossible de publier la mission."
          },
          "create": {
            "success": "Mission créée.",
            "failure": "Impossible de créer la mission."
          },
          "update": {
            "success": "Mission mise à jour.",
            "failure": "Impossible de mettre à jour la mission."
          },
          "archive": {
            "success": "Mission archivée.",
            "failure": "Impossible d'archiver la mission."
          },
          "unarchive": {
            "success": "Mission restaurée.",
            "failure": "Impossible de restaurer la mission."
          },
          "destroy": {
            "success": "Mission supprimée.",
            "failure": "Impossible de supprimer la mission.",
            "confirm": "Cela supprimera définitivement la mission ainsi que toutes ses équipes, vaisseaux et postes. Cette action est irréversible."
          }
        },
        "missionTeam": {
          "create": {
            "success": "Équipe ajoutée.",
            "failure": "Impossible d'ajouter l'équipe."
          },
          "update": {
            "success": "Équipe mise à jour.",
            "failure": "Impossible de mettre à jour l'équipe."
          },
          "destroy": {
            "success": "Équipe retirée.",
            "failure": "Impossible de retirer l'équipe."
          }
        },
        "missionShip": {
          "create": {
            "success": "Vaisseau ajouté.",
            "failure": "Impossible d'ajouter le vaisseau."
          },
          "update": {
            "success": "Vaisseau mis à jour.",
            "failure": "Impossible de mettre à jour le vaisseau."
          },
          "destroy": {
            "success": "Vaisseau retiré.",
            "failure": "Impossible de retirer le vaisseau."
          },
          "duplicate": {
            "success": "Vaisseau dupliqué.",
            "failure": "Impossible de dupliquer le vaisseau."
          }
        },
        "missionSlot": {
          "create": {
            "success": "Poste ajouté.",
            "failure": "Impossible d'ajouter le poste."
          },
          "update": {
            "success": "Poste mis à jour.",
            "failure": "Impossible de mettre à jour le poste."
          },
          "destroy": {
            "success": "Poste retiré.",
            "failure": "Impossible de retirer le poste."
          }
        },
        "event": {
          "create": {
            "success": "Événement créé.",
            "failure": "Impossible de créer l'événement."
          },
          "update": {
            "success": "Événement mis à jour.",
            "failure": "Impossible de mettre à jour l'événement."
          },
          "archive": {
            "success": "Événement archivé.",
            "failure": "Impossible d'archiver l'événement.",
            "confirm": "Archiver cet événement ? Les membres ne le verront plus dans la liste des événements à venir."
          },
          "unarchive": {
            "success": "Événement restauré depuis les archives.",
            "failure": "Impossible de restaurer l'événement."
          },
          "syncToDiscord": {
            "success": "Événement envoyé vers Discord.",
            "failure": "Impossible d'envoyer l'événement vers Discord.",
            "discord_missing_permissions": "Discord a refusé : il manque au bot une permission dont il a besoin sur votre serveur. Les paramètres Discord de la flotte indiquent laquelle."
          },
          "destroy": {
            "success": "Événement supprimé.",
            "failure": "Impossible de supprimer l'événement.",
            "confirm": "Cela supprimera définitivement l'événement. Cette action est irréversible."
          },
          "publish": {
            "success": "Événement publié — les inscriptions sont maintenant ouvertes.",
            "failure": "Impossible de publier l'événement."
          },
          "lockSignups": {
            "success": "Inscriptions verrouillées.",
            "failure": "Impossible de verrouiller les inscriptions."
          },
          "unlockSignups": {
            "success": "Inscriptions rouvertes.",
            "failure": "Impossible de rouvrir les inscriptions."
          },
          "start": {
            "success": "Événement démarré.",
            "failure": "Impossible de démarrer l'événement."
          },
          "complete": {
            "success": "Événement marqué comme terminé.",
            "failure": "Impossible de terminer l'événement."
          },
          "cancel": {
            "success": "Événement annulé.",
            "failure": "Impossible d'annuler l'événement.",
            "confirm": "Annuler cet événement ? Les participants seront notifiés."
          }
        },
        "eventSignup": {
          "create": {
            "success": "Vous êtes inscrit.",
            "failure": "Impossible de s'inscrire."
          },
          "update": {
            "success": "Inscription mise à jour.",
            "failure": "Impossible de mettre à jour l'inscription."
          },
          "withdraw": {
            "success": "Vous vous êtes désinscrit de l'événement.",
            "failure": "Impossible de se désinscrire.",
            "confirm": "Se désinscrire de cet événement ?"
          },
          "kick": {
            "success": "Inscription retirée.",
            "failure": "Impossible de retirer l'inscription.",
            "confirm": "Retirer l'inscription de ce membre ?"
          }
        },
        "eventAdmin": {
          "create": {
            "success": "Rôle attribué.",
            "failure": "Impossible d'attribuer le rôle."
          },
          "destroy": {
            "success": "Rôle révoqué.",
            "failure": "Impossible de révoquer le rôle.",
            "confirm": "Révoquer le rôle de %{username} pour cet événement ?"
          }
        },
        "eventTeam": {
          "create": {
            "success": "Équipe ajoutée.",
            "failure": "Impossible d'ajouter l'équipe."
          },
          "update": {
            "success": "Équipe mise à jour.",
            "failure": "Impossible de mettre à jour l'équipe."
          },
          "destroy": {
            "success": "Équipe retirée.",
            "failure": "Impossible de retirer l'équipe.",
            "confirm": "Retirer cette équipe ainsi que tous ses vaisseaux et postes ?"
          }
        },
        "eventShip": {
          "create": {
            "success": "Vaisseau ajouté.",
            "failure": "Impossible d'ajouter le vaisseau."
          },
          "update": {
            "success": "Vaisseau mis à jour.",
            "failure": "Impossible de mettre à jour le vaisseau."
          },
          "destroy": {
            "success": "Vaisseau retiré.",
            "failure": "Impossible de retirer le vaisseau.",
            "confirm": "Retirer ce vaisseau et ses postes ?"
          }
        },
        "eventSlot": {
          "create": {
            "success": "Poste ajouté.",
            "failure": "Impossible d'ajouter le poste."
          },
          "update": {
            "success": "Poste mis à jour.",
            "failure": "Impossible de mettre à jour le poste."
          },
          "destroy": {
            "success": "Poste retiré.",
            "failure": "Impossible de retirer le poste."
          }
        },
        "contract": {
          "create": {
            "success": "Contrat créé",
            "failure": "Le contrat n'a pas pu être créé"
          },
          "update": {
            "success": "Contrat enregistré",
            "failure": "Le contrat n'a pas pu être enregistré"
          },
          "item": {
            "create": {
              "failure": "Les marchandises n'ont pas pu être ajoutées"
            },
            "destroy": {
              "failure": "Les marchandises n'ont pas pu être retirées"
            },
            "update": {
              "failure": "Les marchandises n'ont pas pu être modifiées"
            }
          }
        },
        "contracts": {
          "deliverHint": "Envoyez les marchandises depuis un de vos inventaires et choisissez ce contrat pour que la livraison compte.",
          "expiredHint": "Ce contrat a expiré et n'accepte plus de nouvelles livraisons. Les livraisons déjà en route comptent toujours une fois acceptées."
        }
      },
      "notifications": {
        "read": "Notification marquée comme lue",
        "unread": "Notification marquée comme non lue",
        "archived": "Notification archivée",
        "unarchived": "Notification remise dans la boîte de réception",
        "readAll": "Toutes les notifications ont été marquées comme lues",
        "destroyed": "Notification supprimée",
        "destroyedAll": "Toutes les notifications ont été supprimées",
        "actionDone": "Terminé",
        "actionFailed": "Cela n'a pas fonctionné - la notification n'est peut-être plus à jour",
        "error": "Une erreur est survenue",
        "bulk": {
          "read": {
            "one": "%{count} notification marquée comme lue",
            "other": "%{count} notifications marquées comme lues"
          },
          "unread": {
            "one": "%{count} notification marquée comme non lue",
            "other": "%{count} notifications marquées comme non lues"
          },
          "archived": {
            "one": "%{count} notification archivée",
            "other": "%{count} notifications archivées"
          },
          "unarchived": {
            "one": "%{count} notification remise dans la boîte de réception",
            "other": "%{count} notifications remises dans la boîte de réception"
          },
          "destroyed": {
            "one": "%{count} notification supprimée",
            "other": "%{count} notifications supprimées"
          }
        }
      },
      "imports": {
        "cancel": {
          "success": "Import annulé",
          "error": "Impossible d'annuler cet import"
        }
      },
      "payouts": {
        "participantAddedUser": "%{name} ajouté avec son compte FleetYards",
        "participantAddedGuest": "%{name} ajouté comme invité",
        "invalidAmount": "Saisissez un montant, par ex. 1 500,50",
        "currencyUpdated": "Devise mise à jour",
        "tourArchived": "Expédition archivée",
        "tourUnarchived": "Expédition restaurée",
        "tourDeleted": "Expédition supprimée",
        "deleteTourConfirm": "Supprimer cette expédition ? Cette action est irréversible.",
        "archiveTourConfirm": "Archiver cette expédition ? Elle quitte la liste mais conserve son registre.",
        "entryCreated": "Écriture enregistrée",
        "entryUpdated": "Écriture mise à jour",
        "destroyEntryConfirm": "Supprimer cette écriture ? Cette action est irréversible.",
        "entryDestroyed": "Écriture supprimée",
        "participantAdded": "Participant ajouté",
        "participantRemoved": "Participant retiré",
        "participantHasEntries": "Supprimez d'abord ses écritures",
        "settled": "Répartition calculée",
        "reopened": "Registre rouvert",
        "tourCreated": "Expédition créée",
        "tourCreateFailure": "Impossible de créer l'expédition.",
        "tourJoined": "Vous avez rejoint l'expédition",
        "settleConfirm": "Calculer la répartition et verrouiller le registre ? Les écritures ne seront plus modifiables jusqu'à réouverture.",
        "reopenConfirm": "Rouvrir le registre ? La liste de versements actuelle sera abandonnée.",
        "participantNeedsName": "Saisissez un nom d'utilisateur ou un nom",
        "weightUpdated": "Part mise à jour",
        "joinRequested": "Votre demande a été envoyée",
        "joinRequestWithdrawn": "Demande retirée",
        "joinRequestApproved": "Demande acceptée",
        "joinRequestDeclined": "Demande refusée",
        "expenseApproved": "Dépense approuvée",
        "expenseDeclined": "Dépense refusée",
        "pendingReview": "%{count} dépense(s) en attente de validation"
      },
      "dockAddition": {
        "create": {
          "failure": "Impossible d'ajouter ce vaisseau."
        },
        "destroy": {
          "failure": "Impossible de retirer ce vaisseau."
        }
      },
      "dockCapacity": {
        "create": {
          "failure": "Impossible de créer l'entrée de capacité."
        },
        "update": {
          "failure": "Impossible d'enregistrer l'entrée de capacité."
        },
        "destroy": {
          "failure": "Impossible de supprimer l'entrée de capacité."
        }
      },
      "dock": {
        "create": {
          "failure": "Impossible de créer le quai."
        },
        "update": {
          "failure": "Impossible d'enregistrer le quai."
        },
        "destroy": {
          "failure": "Impossible de supprimer le quai."
        }
      },
      "relationships": {
        "user": {
          "addHint": "Saisissez le nom d'utilisateur de la personne à ajouter. Elle devra accepter."
        },
        "fleet": {
          "addHint": "Saisissez l'identifiant de la flotte avec laquelle vous voulez vous allier. Ses administrateurs devront accepter."
        }
      },
      "friends": {
        "request": {
          "success": "Demande envoyée",
          "failure": "Impossible d'envoyer la demande"
        },
        "accept": {
          "success": "Demande acceptée",
          "failure": "Impossible d'accepter la demande"
        },
        "decline": {
          "success": "Demande refusée",
          "failure": "Impossible de refuser la demande"
        },
        "ignore": {
          "success": "Demande ignorée",
          "failure": "Impossible d'ignorer la demande"
        },
        "remove": {
          "success": "Supprimé",
          "failure": "Impossible de supprimer"
        }
      },
      "fleetAllies": {
        "request": {
          "success": "Demande envoyée",
          "failure": "Impossible d'envoyer la demande"
        },
        "accept": {
          "success": "Demande acceptée",
          "failure": "Impossible d'accepter la demande"
        },
        "decline": {
          "success": "Demande refusée",
          "failure": "Impossible de refuser la demande"
        },
        "ignore": {
          "success": "Demande ignorée",
          "failure": "Impossible d'ignorer la demande"
        },
        "remove": {
          "success": "Supprimé",
          "failure": "Impossible de supprimer"
        }
      },
      "vehiclePlaque": {
        "removeConfirm": "Retirer la plaque de dédicace de ce vaisseau ?",
        "downloadFailure": "La plaque n'a pas pu être enregistrée en image",
        "failure": "La plaque n'a pas pu être enregistrée"
      },
      "vehicleOverview": {
        "image": {
          "success": "Image enregistrée",
          "failure": "L'image n'a pas pu être enregistrée"
        },
        "paint": {
          "failure": "La peinture n'a pas pu être appliquée"
        },
        "setting": {
          "failure": "Le réglage n'a pas pu être enregistré"
        },
        "location": {
          "failure": "L'emplacement n'a pas pu être enregistré"
        }
      },
      "vehicleLog": {
        "create": {
          "success": "Entrée ajoutée",
          "failure": "L'entrée n'a pas pu être ajoutée"
        },
        "update": {
          "success": "Entrée enregistrée",
          "failure": "L'entrée n'a pas pu être enregistrée"
        },
        "destroy": {
          "failure": "L'entrée n'a pas pu être supprimée"
        },
        "defaultUpdate": {
          "failure": "Le réglage n'a pas pu être enregistré"
        }
      },
      "vehicleLoadout": {
        "failure": "La configuration n'a pas pu être enregistrée."
      },
      "hangarPledgeItems": {
        "addedToInventory": {
          "one": "%{count} élément ajouté à %{inventory}",
          "other": "%{count} éléments ajoutés à %{inventory}"
        },
        "addToInventoryFailed": "Les éléments n'ont pas pu être ajoutés à l'inventaire."
      }
    }
  }
}
